import { Pipe, PipeTransform } from '@angular/core';
import { TSource } from '@core/types/tsource';
import { environment } from '@env/environment';

import { EnApi } from '../../api/enums/api.enums';

@Pipe({
  name: 'src',
  standalone: true,
})
export class SrcPipe implements PipeTransform {
  transform(value: string, type: TSource = 'store'): string {
    switch (type) {
      case 'store': {
        return `${EnApi.CDN}/${value}`;
      }
      case 'origin': {
        return `${EnApi.CDN}/storage/projects/origin/${value}`;
      }
      case 'assets': {
        return `${environment.ASSETS_IMAGES}/${value}`;
      }
      case 'country-flag': {
        return `${EnApi.CDN}/flags/${value?.toLocaleLowerCase()}.svg`;
      }
      case 'tui': {
        return `${environment.ASSETS_PATH}/taiga-ui/${value}`;
      }
      default: {
        return value;
      }
    }
  }
}
